import styles from './VServices.module.css'
import VTitle from '../../common/VTitle'
// Modal
import Modal_1 from '../../common/Modals/Modal_1';
import useScrollBlock from '../../../../customHooks/useScrollBlock';
// Modal Details
import VServicesModalDeliveryDetails from './modals/delivery/VServicesModalDeliveryDetails';
import VServicesModalRepairDetails from './modals/repair/VServicesModalRepairDetails';
import VServicesModalCleaningDetails from './modals/cleaning/VServicesModalCleaningDetails';
import VServicesModalRentDetails from './modals/rent/VServicesModalRentDetails';
import VServicesModalReturnDetails from './modals/return/VServicesModalReturnDetails';
import VServicesModalRecycleDetails from './modals/recycle/VServicesModalRecycleDetails';
// Modal Orders
import VServicesModalRepairOrder from './modals/repair/VServicesModalRepairOrder';

// Pictures
import pic_delivery from './modals/delivery/image.jpg'
import pic_repair from './modals/repair/image.jpg'
import pic_cleaning from './modals/cleaning/image.jpg'
import pic_rent from './modals/rent/image.jpg'
import pic_return from './modals/return/return.png'
import pic_recycle from './modals/recycle/image.jpg'



const Box = ({ title, img, showDetails = false, showPayment = false, detailsModal, paymentModal }) => {
  const [blockScroll, allowScroll] = useScrollBlock();

  const openDetails = () => {
    // setTimeout(function(){}, 150);
    blockScroll()
    if (detailsModal) {
      Modal_1.open(detailsModal);
    }
  }
  const openOrder = () => {
    // setTimeout(function(){}, 150);
    blockScroll()
    if (paymentModal) {
      Modal_1.open(paymentModal);
    }
  }
  return(
              <div className={"card__wrapper " + styles.card__wrapper}>
                  <div className={"card__content " + styles.card}>
                      <h3 className={styles.title}>{title}</h3>
                      <img className={styles.service_img} src={img} alt = {title} />

                      <div className={styles.btn_block}>
                          {showDetails && <button onClick={openDetails} className={styles.btn_outer_blue}>Подробнее</button>}
                          {showPayment && <button onClick={openOrder} className={styles.btn_solid_blue}>Оплатить</button>}
                      </div>

                  </div>
              </div>
  )
}

const VServices = () => {
  return (
    <>
    <div className={styles.page_wrapper}>
        <VTitle title="Услуги" subtitle="мы с готовностью предоставляем  спектр качественных услуг для удовлетворения ваших потребностей" />

        <div className={styles.wrapper}>

            <Box 
              title="Служба доставки"  
              img={pic_delivery} 
              showDetails={true} 
              detailsModal={VServicesModalDeliveryDetails}
            />
            <Box 
              title="Ремонт питьевых аппаратов"  
              img={pic_repair} 
              showDetails={true} 
              showPayment={true}
              detailsModal={VServicesModalRepairDetails}
              paymentModal={VServicesModalRepairOrder}
            />
            <Box 
              title="Санитарная обработка и промывка аппаратов"  
              img={pic_cleaning} 
              showDetails={true}
              detailsModal={VServicesModalCleaningDetails}
            />
            <Box 
              title="Аренда складских помещений"  
              img={pic_rent} 
              showDetails={true}
              detailsModal={VServicesModalRentDetails}
            />
            <Box 
              title="Возврат тары"  
              img={pic_return} 
              showDetails={true}
              detailsModal={VServicesModalReturnDetails}
            />
            <Box 
              title="Реализация вторичного сырья"  
              img={pic_recycle} 
              showDetails={true}
              detailsModal={VServicesModalRecycleDetails}
            />
            
        </div>
      </div>
    </>
  )
}

export default VServices
